import { render, staticRenderFns } from "./StandardApparatus.vue?vue&type=template&id=09b2c5bc&scoped=true"
import script from "./StandardApparatus.vue?vue&type=script&lang=ts"
export * from "./StandardApparatus.vue?vue&type=script&lang=ts"
import style0 from "./StandardApparatus.vue?vue&type=style&index=0&id=09b2c5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2c5bc",
  null
  
)

export default component.exports